import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { defectNoticeDefectClassesSchema } from '../../../common/validations/defectNotice'

import { get } from 'api/apiClient'

const params = {
  queryKey: [API_ENDPOINTS.DEFECT_CLASSES],
  queryFn: () =>
    get(`${API_ENDPOINTS.DEFECT_CLASSES}`, defectNoticeDefectClassesSchema),
}

export const useAPIGetDefectClasses = () => useQuery(params)

export const useAPIGetDefectClassesSuspense = () => useSuspenseQuery(params)
